'use client';

import { useCallback } from 'react';
import { useSearchParams } from 'next/navigation';

export function usePreservedQueryPath(): (path: string) => string {
  const searchParams = useSearchParams();

  return useCallback(
    (path: string) => {
      const query = searchParams?.toString() ?? '';
      if (!query) return path;
      return path.includes('?') ? `${path}&${query}` : `${path}?${query}`;
    },
    [searchParams],
  );
}
